<template>
    <LoaderIndicatorPage />
    <NuxtLayout>
        <NuxtPage />
    </NuxtLayout>
    <vue-notification-list />
</template>
